module.exports = __webpack_public_path__ + "static/media/1022210.b5e9a533.jpg";